import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetPaymentMethodsBillingQueryVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
}>;


export type GetPaymentMethodsBillingQuery = { __typename?: 'query_root', arpaymentmethods: Array<{ __typename?: 'arpaymentmethods', id: number, customer_id: number, gateway_token: string, active: boolean, type: string, routing_number?: number | null, account_type?: string | null, account_number: number, expiration?: number | null, card_type?: string | null, primary: boolean, name: string, source: string, gateway: string, bank_name: string, pending_setup_intent_id?: string | null }> };


export const GetPaymentMethodsBillingDocument = gql`
    query getPaymentMethodsBilling($customerId: bigint!) {
  arpaymentmethods(
    where: {customer_id: {_eq: $customerId}, active: {_eq: true}, type: {_neq: "manual"}}
    order_by: {primary: desc}
  ) {
    id
    customer_id
    gateway_token
    active
    type
    routing_number
    account_type
    account_number
    expiration
    card_type
    primary
    name
    source
    gateway
    bank_name
    pending_setup_intent_id
  }
}
    `;

/**
 * __useGetPaymentMethodsBillingQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodsBillingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodsBillingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodsBillingQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetPaymentMethodsBillingQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentMethodsBillingQuery, GetPaymentMethodsBillingQueryVariables> & ({ variables: GetPaymentMethodsBillingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentMethodsBillingQuery, GetPaymentMethodsBillingQueryVariables>(GetPaymentMethodsBillingDocument, options);
      }
export function useGetPaymentMethodsBillingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentMethodsBillingQuery, GetPaymentMethodsBillingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentMethodsBillingQuery, GetPaymentMethodsBillingQueryVariables>(GetPaymentMethodsBillingDocument, options);
        }
// @ts-ignore
export function useGetPaymentMethodsBillingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaymentMethodsBillingQuery, GetPaymentMethodsBillingQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaymentMethodsBillingQuery, GetPaymentMethodsBillingQueryVariables>;
export function useGetPaymentMethodsBillingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentMethodsBillingQuery, GetPaymentMethodsBillingQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaymentMethodsBillingQuery | undefined, GetPaymentMethodsBillingQueryVariables>;
export function useGetPaymentMethodsBillingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentMethodsBillingQuery, GetPaymentMethodsBillingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentMethodsBillingQuery, GetPaymentMethodsBillingQueryVariables>(GetPaymentMethodsBillingDocument, options);
        }
export type GetPaymentMethodsBillingQueryHookResult = ReturnType<typeof useGetPaymentMethodsBillingQuery>;
export type GetPaymentMethodsBillingLazyQueryHookResult = ReturnType<typeof useGetPaymentMethodsBillingLazyQuery>;
export type GetPaymentMethodsBillingSuspenseQueryHookResult = ReturnType<typeof useGetPaymentMethodsBillingSuspenseQuery>;
export type GetPaymentMethodsBillingQueryResult = Apollo.QueryResult<GetPaymentMethodsBillingQuery, GetPaymentMethodsBillingQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/billing/queries/getPaymentMethodsBilling.query.gql}
 */
export async function getPaymentMethodsBilling(
  variables: GetPaymentMethodsBillingQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetPaymentMethodsBillingQuery['arpaymentmethods']>
export async function getPaymentMethodsBilling(
  variables: GetPaymentMethodsBillingQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetPaymentMethodsBillingQuery>
export async function getPaymentMethodsBilling(
  variables: GetPaymentMethodsBillingQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetPaymentMethodsBillingQuery['arpaymentmethods'] | GetPaymentMethodsBillingQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetPaymentMethodsBillingQuery>(
    GetPaymentMethodsBillingDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.arpaymentmethods
}